import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import Container from "../common/Container";

const Error403 = () => (
  <Container>
    <Grid container style={{ margin: 24 }}>
      <Grid item>
        <h1>Forbidden</h1>
        <p>Sorry, you are not authorised to view this page.</p>
        <Button variant="contained" color="primary" component={Link} to="/">
          Home
        </Button>
      </Grid>
    </Grid>
  </Container>
);

export default Error403;
